<template>
  <formatted-text-input
    v-bind="{ label, required, requiredClass, requiredText, id, name, placeholder, error, disabled }"
    :options="options"
    :classes="[isValid ? inputValidClass : false, classes]"
    :right-icon="isValid ? iconValid : ''"
    :icon-class="isValid ? iconsValidClass : false"
    :emit-raw="false"
    @input="emit">
    <slot/>
  </formatted-text-input>
</template>

<script>
import * as props from '../mixins/props'
import cardValidator from 'card-validator'

export default {

  mixins: [
    props.classes,
    props.disabled,
    props.error,
    props.id,
    props.label,
    props.name,
    props.required,
  ],

  props: {
    iconValid: {
      type: String,
      default: 'check',
    },
    iconsValidClass: {
      type: String,
      default: 'has-text-success',
    },
    inputValidClass: {
      type: String,
      default: 'is-success',
    },
    placeholder: {
      type: String,
      default: 'MM/YYYY'
    }
  },

  data() {
    return {
      isValid: false,
    }
  },

  computed: {
    options() {
      return {
        date: true,
        datePattern: ['m', 'Y']
      }
    }
  },

  methods: {
    emit(value) {
      let [ month, year ] = value.split('/', 2),
          validation = cardValidator.expirationDate(month + year)
      this.isValid = month.length === 2 && year.length === 4 && validation.isValid
      this.$emit('input', { month, year })
      this.$emit('valid', this.isValid)
    },
  },

}
</script>
